export const GENERIC_ERROR_MSG =
    'Something went wrong while loading or submitting this authorization. If the problem persists, please reach out to a FinPay administrator at support@finpay.com.';
